import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabPreferitiPage } from './tabPreferiti.page';
import { MomentModule } from 'ngx-moment';
import { ComponentsModule } from 'src/app/components/components.modules';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    MomentModule,
    ComponentsModule,
    RouterModule.forChild([{ path: '', component: TabPreferitiPage }]),
    TranslateModule.forChild()
  ],
  declarations: [TabPreferitiPage]
})
export class TabPreferitiPageModule { }
